export { default } from './ApplyRegistrationPopupСombined';
